// extracted by mini-css-extract-plugin
module.exports = {"emptyNode":"JobFunctionSinglePc_emptyNode__6DrRs","highlightSpan":"JobFunctionSinglePc_highlightSpan__gpu_N"};